import axios from 'axios'
import { get } from '@bigyouth/base'
import { ACTIONS as MODAL_ACTIONS } from './modal'
import { get as getPipe } from '../utils/sigpipe'

export default {
  name: 'axios-call',

  events: [
    {
      on: 'click',
      handle () {
        const datas = new FormData()

        if (this.props.datas) {
          for (const [key, value] of Object.entries(this.props.datas)) {
            datas.append(key, value)
          }
        }

        if (this.props.hasLoader) {
          const loader = document.createElement('div')
          loader.classList.add('loader')
          this.el.prepend(loader)
          this.el.classList.add('is-loading')
        }

        axios.post(this.props.url, datas)
          .then(response => {
            if (response.data.success) {
              window.dispatchEvent(new CustomEvent('axios-response', { detail: { data: response.data } }))
              if (this.props.hasLoader) {
                get('.loader', this.el).remove()
                this.el.classList.remove('is-loading')
              }
              if (this.props.goTo) {
                window.location.href = this.props.goTo
              } else {
                if (this.props.action && this.props.action === 'remove') {
                  this.el.closest(this.props.target).remove()
                } else if (this.props.reload) {
                  document.location.reload()
                }
              }
            } else {
              if (response.data.message === 'API Ammon Not Responding.') {
                this.displayPopinError()
              }
            }
          })
          .catch(e => {
            if (this.props.popinError) {
              this.displayPopinError()
            } else {
              console.log(e)
            }
          })
      },
    },
  ],

  componentDidMount () {
  },

  displayPopinError () {
    const modal = get('#error-registration-training')
    this.modalPipe = getPipe(modal.getAttribute('data-pipe-id'))
    this.modalPipe.write({ action: MODAL_ACTIONS.OPEN, emitterEl: this.el })

    if (this.props.hasLoader) {
      get('.loader', this.el).remove()
      this.el.classList.remove('is-loading')
    }
  },
}
